<template>
  <div>
    <div>
      <v-tooltip top>
        <template slot="activator">
          <v-btn
            block
            :loading="cancelPending"
            :disabled="cancelPending"
            color="error"
            @click="getCancelDetails"
          >
            <v-icon left>
              cancel
            </v-icon>
            Cancel
          </v-btn>
        </template>
        <span
          >Cancel shift - you will have a chance to confirm after seeing
          cancellation details</span
        >
      </v-tooltip>

      <v-dialog v-model="cancelDialog" max-width="400">
        <v-card>
          <v-card-text class="text-xs-center">
            <h2 class="headline">
              Cancel this shift?
            </h2>

            <div v-if="fetchingDetails">
              <v-progress-linear indeterminate />
              Getting details...
            </div>
            <div v-else>
              {{ cancellationMessage }}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              :loading="cancelPending"
              :disabled="cancelPending || fetchingDetails"
              flat
              small
              @click="cancelDialog = false"
              >Nevermind</v-btn
            >
            <v-btn block color="primary" @click="continueToCancel"
              >I Understand</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="doCancelDialog" max-width="400">
        <v-card>
          <v-card-text class="text-xs-center">
            <h2 class="headline mb-2">
              Cancelling Shift
            </h2>

            <v-textarea v-model="cancelNotes" label="Notes / Reason" box>
            </v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              :loading="cancelPending"
              :disabled="cancelPending"
              flat
              small
              @click="doCancelDialog = false"
              >Nevermind</v-btn
            >
            <v-btn
              block
              color="error"
              :loading="cancelPending"
              :disabled="cancelPending"
              @click="doCancellation"
              >Cancel Shift</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import shiftApi from '@/api/shift';

  export default {
    props: ['shift'],
    components: {},
    computed: {
      ...mapState('userAuth', ['user']),
      shiftTooSoon() {
        const twentyFourHours = this.$moment().add(24, 'hours');
        const shiftStart = this.$moment(this.shift.startDatetime);
        if (shiftStart - twentyFourHours < 0) {
          return true;
        }
        return false;
      },
      shiftInUserTeams() {
        return this.user.clientWorksiteIds.includes(this.shift.worksiteId);
      },
    },
    created() {
      this.setUp();
    },
    watch: {},
    data: function() {
      return {
        fetchingDetails: false,
        cancelPending: false,
        cancellationMessage: '',
        cancelDialog: false,
        doCancelDialog: false,
        cancelNotes: '',
      };
    },
    methods: {
      getCancelDetails() {
        this.cancelDialog = true;
        this.fetchingDetails = true;
        shiftApi.cancellationDetails(
          {shiftId: this.shift.id},
          res => {
            this.cancellationMessage = res.message;
            this.fetchingDetails = false;
          },
          error => {
            console.log(error);
            this.fetchingDetails = false;
          },
        );
      },

      continueToCancel() {
        this.cancelDialog = false;
        this.doCancelDialog = true;
      },

      doCancellation() {
        this.cancelPending = true;
        shiftApi.cancel(
          {shiftId: this.shift.id, notes: this.cancelNotes},
          res => {
            this.cancelPending = false;
            this.$store.dispatch(
              'global/showSnackbarSuccess',
              {message: 'Shift cancelled!'},
              {root: true},
            );
            this.$router.push('/');
          },
          error => {
            console.log(error);
            this.cancelPending = false;
          },
        );
      },
      cancelShift() {},
      setUp() {},
    },
  };
</script>

<style scoped></style>
